/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useNavigate } from "react-router-dom";

// CSS読み込み
import { backButton } from "assets/css/stylesCss";

/**
 * 前の画面に戻るボタン
 * @param {String} url 遷移先のURL
 * @param {function} fn ボタン押下時の挙動
 */
const BackButton = memo(({ url, fn }) => {
  const navigate = useNavigate();

  return (
    <button
      css={backButton}
      onClick={() => {
        if (fn) fn();
        if (url) {
          navigate(url, {
            state: { isSubmit: true },
          });
        } else {
          // 一つ前の画面に戻る
          navigate(-1, {
            state: { isSubmit: true },
          });
        }
      }}
    >
      戻る
    </button>
  );
});

export default BackButton;
